<div class="region-assessment">
  <div class="region-assessment__head">
    <h4
      class="h4 region-assessment__title"
      [innerHTML]="page?.translation?.data?.mapsTitle"
    >
      Кількість поданих актів по областям
    </h4>
  </div>

  <div class="region-assessment__content">
    <div class="map" #mapContainerRef>
      <svg width="1131" height="753" viewBox="0 0 1131 753">
        <g
          *ngFor="let region of regionsData"
          (click)="onRegionPopupOpen(region, regionRef)"
          class="region"
          #regionRef
        >
          <path
            *ngFor="let path of region.paths"
            [attr.d]="path.d"
            [attr.fill]="getRegionColor(region.countPra)"
            [attr.stroke]="path.stroke"
            [attr.stroke-width]="path.strokeWidth"
            [attr.stroke-linecap]="path.strokeLinecap"
            [attr.stroke-linejoin]="path.strokeLinejoin"
          ></path>
        </g>

        <text
          *ngFor="let region of regionsData"
          [attr.x]="region.labelX"
          [attr.y]="region.labelY"
          text-anchor="middle"
          dominant-baseline="middle"
          class="region-label"
        >
          {{ region.name }}
        </text>
      </svg>

      <div
        *ngIf="selectedRegion"
        class="popup"
        [style.left.px]="selectedRegion.popupX"
        [style.top.px]="selectedRegion.popupY"
      >
        <div class="popup__head">
          <div class="popup__name">
            {{ selectedRegion?.name
            }}{{
              selectedRegion?.id !== "26" && selectedRegion?.id !== "1"
                ? " обл."
                : ""
            }}
          </div>
          <button class="popup__close" (click)="onRegionPopupClose()">×</button>
        </div>
        <div class="popup__count">
          {{ page?.translation?.data?.countPraTitle }}:
          {{ selectedRegion.countPra || 0 }}
        </div>
      </div>
      <div class="scale">
        <div class="scale__count">
          <span class="number">200</span>
          <span class="number"></span>
          <span class="number">400</span>
          <span class="number"></span>
          <span class="number">600+</span>
        </div>
        <img
          class="scale__img"
          ngSrc="assets/img/icons/scale.svg"
          width="270"
          height="13"
          alt="scale"
        />
        <div class="scale__text">
          <span>Мінімум</span>
          <span>Максимум</span>
        </div>
      </div>
    </div>
  </div>
</div>
